export type ThresholdConfig = {
	warning: number;
	error: number;
};

export type ThresholdMode = "higherIsBetter" | "lowerIsBetter" | "closestToTarget";

export enum ThresholdStatus {
	GOOD = "good",
	WARNING = "warning",
	ERROR = "error",
}
